import WSGTDriveIndex from "@/views/wsgtdrive/Index.vue";
import WSGTDriveList from "@/views/wsgtdrive/List.vue";
import WSGTDriveEdit from "@/views/wsgtdrive/Edit.vue";
import WSGTDriveProgressUpdate from "@/views/wsgtdrive/ProgressUpdate.vue";
// import Participation from "@/views/wsgtdrive/Participation.vue";
// import TransactionLog from "@/views/wsgtdrive/TransactionLog.vue";

export default {
  path: "/wsgtdrive",
  name: "WSGTDriveIndex",
  component: WSGTDriveIndex,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "campaign",
      name: "WSGTDriveList",
      component: WSGTDriveList,
      meta: {
        requiresAuth: true,
        roles: ["admin"],
      },
    },
    {
      path: "campaign/edit/:id",
      name: "WSGTDriveEdit",
      component: WSGTDriveEdit,
      meta: {
        requiresAuth: true,
        roles: ["admin"],
      },
    },
    {
      path: "campaign/:id/progress-update",
      name: "WSGTDriveProgressUpdate",
      component: WSGTDriveProgressUpdate,
      meta: {
        requiresAuth: true,
        roles: ["admin"],
      },
    },
  ],
};
